<template>
  <BottomStackItem layer="notifications">
    <NotificationCard
      v-if="visible"
      message="Update available"
      detail="A new version of RightMessage is ready."
      :actions="[{ label: 'Reload', onClick: systemStore.reloadApp }]"
      dismiss-label="Dismiss update notice"
      @dismiss="dismiss">
      <template #icon>
        <ArrowPathIcon class="size-[18px] text-sky-300" aria-hidden="true" />
      </template>
    </NotificationCard>
  </BottomStackItem>
</template>

<script setup lang="ts">
import BottomStackItem from '@dashboard/components/common/BottomStackItem.vue'
import NotificationCard from '@dashboard/components/common/NotificationCard.vue'
import { useNotificationStore } from '@dashboard/stores/notificationStore'
import { useSystemStore } from '@dashboard/stores/systemStore'
import { ArrowPathIcon } from '@heroicons/vue/24/outline'
import { computed, ref } from 'vue'

const systemStore = useSystemStore()
const notificationStore = useNotificationStore()

// Dismissal covers the build that was announced; a later deploy shows the notice again.
const dismissedBuildId = ref<string | null | undefined>(undefined)
const visible = computed(
  () =>
    systemStore.newVersionAvailable &&
    !systemStore.maintenanceMode &&
    dismissedBuildId.value !== systemStore.targetBuildId
)

function dismiss() {
  dismissedBuildId.value = systemStore.targetBuildId
  notificationStore.add({
    type: 'warn',
    message: 'Some parts of RightMessage might not work correctly until you reload.',
    life: 10000,
    action: { label: 'Reload', onClick: systemStore.reloadApp }
  })
}
</script>
